module.exports = __webpack_public_path__ + "media/media/home/img2-a9f39eae690b0a080f95535622fc01b9.png";